function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M497.4 60.46C516.1 79.2 516.1 109.6 497.4 128.3L176 449.7C163.7 461.1 148.5 471 131.8 475.9L10.26 511.7C7.449 512.5 4.413 511.7 2.343 509.7C.2733 507.6-.5008 504.6 .3254 501.7L36.08 380.2C40.99 363.5 50.02 348.3 62.32 335.1L383.7 14.63C402.4-4.12 432.8-4.12 451.5 14.63L497.4 60.46zM328.1 92.8L419.2 183.9L486.1 117C498.6 104.5 498.6 84.27 486.1 71.77L440.2 25.94C427.7 13.44 407.5 13.44 394.1 25.94L328.1 92.8zM316.8 104.1L73.63 347.3C63.22 357.7 55.59 370.5 51.43 384.7L19.81 492.2L127.3 460.6C141.5 456.4 154.3 448.8 164.7 438.4L407.9 195.2L316.8 104.1z"
});

function SvgPenThin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenThin);
export default __webpack_public_path__ + "static/media/pen-thin.8ee0568d.svg";
export { ForwardRef as ReactComponent };